import { render, staticRenderFns } from "./QueryBody.vue?vue&type=template&id=c53a50d4&scoped=true&"
import script from "./QueryBody.vue?vue&type=script&lang=js&"
export * from "./QueryBody.vue?vue&type=script&lang=js&"
import style0 from "./QueryBody.vue?vue&type=style&index=0&id=c53a50d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53a50d4",
  null
  
)

export default component.exports